

















import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class UIAlertMessage extends Vue {
  @Prop() value!: boolean;
  @Prop() title!: string;
  @Prop() message!: string;

  @Emit()
  public input(value: boolean) {}

  private get localValue(): boolean {
    return this.value;
  }

  private set localValue(value: boolean) {
    this.input(value);
  }
}
